import { AgentHarnessRooms } from './rooms/agent.harness.rooms';
import { ExtensionAgentRooms } from './rooms/extension.agent.rooms';
import { AIRooms } from './rooms/ai.rooms';
import { EntityRooms } from './rooms/entity.rooms';
import { InboxRooms } from './rooms/inbox.rooms';
import { MessageReliabilityRooms } from './rooms/message.reliability.rooms';
import { NotificationSettingsRooms } from './rooms/settings.user.notification.rooms';
import { PersonalTokenSettingsRooms } from './rooms/settings.user.personal.token.rooms';
import { TenantRooms } from './rooms/tenant.rooms';
import { UserRooms } from './rooms/user.rooms';
import { UserSecuritySettingsRooms } from './rooms/settings.user.security.rooms';
import { GeneralSettingsRooms } from './rooms/settings.general.rooms';
import { PublicApiRateLimitSettingsRooms } from './rooms/settings.public.api.rate.limit.rooms';
import { VisitApprovalRooms } from './rooms/visit.approval.rooms';
export * from './rooms/visit.approval.rooms';

export * from './socket.room.key';
export * from './rooms/agent.harness.rooms';
export * from './rooms/extension.agent.rooms';
export * from './rooms/ai.rooms';
export * from './rooms/entity.rooms';
export * from './rooms/inbox.rooms';
export * from './rooms/message.reliability.rooms';
export * from './rooms/settings.user.notification.rooms';
export * from './rooms/settings.user.personal.token.rooms';
export * from './rooms/tenant.rooms';
export * from './rooms/user.rooms';
export * from './rooms/settings.user.security.rooms';
export * from './rooms/settings.general.rooms';
export * from './rooms/settings.public.api.rate.limit.rooms';

/**
 * Socket room registry for type-safe room subscriptions.
 */
export const SocketRooms = {
    ...VisitApprovalRooms,
    ...EntityRooms,
    ...AIRooms,
    ...InboxRooms,
    ...TenantRooms,
    ...UserRooms,
    ...NotificationSettingsRooms,
    ...PersonalTokenSettingsRooms,
    ...UserSecuritySettingsRooms,
    ...GeneralSettingsRooms,
    ...PublicApiRateLimitSettingsRooms,
    ...AgentHarnessRooms,
    ...ExtensionAgentRooms,
    ...MessageReliabilityRooms,
};
